import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BindCssVariableModule } from '../../directives/bind-css-variable.directive';
import { AnimatedCircleIconModule } from '../../components/animated-circle-icon/animated-circle-icon.component';
import { CheckboxWithHoverPointModule } from '../../components/checkbox-with-hover-point/checkbox-with-hover-point.component';
import { CloseButtonModule } from '../../components/close-button/close-button.component';
import { GenericTileBodyModule } from '../../components/generic-tile-body/generic-tile-body.component';
import { DateArrayToStringPipeModule } from '../../pipes/date-array-to-string.pipe';
import { SharedModule } from '../../shared/shared.module';
import { LiveClassSharedModule } from '../live-class-shared/live-class-shared.module';
import { GroupClassCarouselComponent } from './group-class/group-class-carousel/group-class-carousel.component';
import { GroupClassTileStatesComponent } from './group-class/group-class-tile/group-class-tile-states/group-class-tile-states.component';
import { GroupClassStateCanSignUpComponent } from './group-class/group-class-tile/group-class-tile-states/states/group-class-state-can-sign-up.component';
import { GroupClassStateHasJoinComponent } from './group-class/group-class-tile/group-class-tile-states/states/group-class-state-has-join.component';
import { GroupClassStateLockedComponent } from './group-class/group-class-tile/group-class-tile-states/states/group-class-state-locked.component';
import { GroupClassStateNoneComponent } from './group-class/group-class-tile/group-class-tile-states/states/group-class-state-none.component';
import { GroupClassStateSignUpConfirmComponent } from './group-class/group-class-tile/group-class-tile-states/states/group-class-state-sign-up-confirm.component';
import { GroupClassStateSignedUpComponent } from './group-class/group-class-tile/group-class-tile-states/states/group-class-state-signed-up.component';
import { GroupClassTileComponent } from './group-class/group-class-tile/group-class-tile.component';
import { GroupClassCardComponent } from './group-class/group-class-card/group-class-card.component';
import { LiveClassRevampSectionComponent } from './live-class-revamp-section/live-class-revamp-section.component';
import { LiveClassStateViewTimerComponent } from './live-class-state-view-timer/live-class-state-view-timer.component';
import { LiveClassStateViewTitleComponent } from './live-class-state-view-title/live-class-state-view-title.component';
import { LiveClassWithCountdownTimerComponent } from './live-class-with-countdown-timer/live-class-with-countdown-timer.component';
import { PrivateClassBannerContainerComponent } from './private-class-banner/private-class-banner-container/private-class-banner-container.component';
import { PrivateClassBannerComponent } from './private-class-banner/private-class-banner.component';
import { PrivateClassCenterHeaderBannerComponent } from './private-class-banner/private-class-center-header-banner/private-class-center-header-banner.component';
import { PrivateClassDownloadSlidesLinkComponent } from './private-class-banner/private-class-download-slides-link/private-class-download-slides-link.component';
import { PrivateClassFeedbackModalComponent } from './private-class-banner/private-class-feedback-modal/private-class-feedback-modal.component';
import { PrivateClassBannerImageComponent } from './private-class-banner/private-class-left-header-banner/private-class-banner-image/private-class-banner-image.component';
import { PrivateClassHeaderComponent } from './private-class-banner/private-class-left-header-banner/private-class-header/private-class-header.component';
import { PrivateClassLeftHeaderBannerComponent } from './private-class-banner/private-class-left-header-banner/private-class-left-header-banner.component';
import { PrivateClassLessonContainerComponent } from './private-class-banner/private-class-lesson-container/private-class-lesson-container.component';
import { PrivateClassLessonDetailBoxComponent } from './private-class-banner/private-class-lesson-detail-box/private-class-lesson-detail-box.component';
import { PrivateClassLessonElementComponent } from './private-class-banner/private-class-lesson-element/private-class-lesson-element.component';
import { PrivateClassLessonListComponent } from './private-class-banner/private-class-lesson-list/private-class-lesson-list.component';
import { PrivateClassStateCanSignUpComponent } from './private-class-banner/private-class-states/private-class-state-can-sign-up.component';
import { PrivateClassStateHasJoinComponent } from './private-class-banner/private-class-states/private-class-state-has-join.component';
import { PrivateClassStateLessonSelectComponent } from './private-class-banner/private-class-states/private-class-state-lesson-select.component';
import { PrivateClassStateLockedComponent } from './private-class-banner/private-class-states/private-class-state-locked.component';
import { PrivateClassStateNoneComponent } from './private-class-banner/private-class-states/private-class-state-none.component';
import { PrivateClassStateSignUpConfirmComponent } from './private-class-banner/private-class-states/private-class-state-sign-up-confirm.component';
import { PrivateClassStateSignedUpComponent } from './private-class-banner/private-class-states/private-class-state-signed-up.component';
import { PrivateClassThankYouModalComponent } from './private-class-banner/private-class-thank-you-modal/private-class-thank-you-modal.component';
import { PrivateClassUpsellBannerComponent } from './private-class-banner/private-class-upsell-banner/private-class-upsell-banner.component';
import { PrivateClassWithoutTrackBannerComponent } from './private-class-banner/private-class-without-track-banner/private-class-without-track-banner.component';

@NgModule({
  imports: [
    CommonModule,
    LiveClassSharedModule,
    SharedModule,
    GenericTileBodyModule,
    DateArrayToStringPipeModule,
    CloseButtonModule,
    AnimatedCircleIconModule,
    CheckboxWithHoverPointModule,
    BindCssVariableModule,
  ],
  declarations: [
    LiveClassRevampSectionComponent,
    GroupClassCarouselComponent,
    GroupClassTileComponent,
    GroupClassCardComponent,
    PrivateClassWithoutTrackBannerComponent,
    PrivateClassBannerComponent,
    PrivateClassLessonListComponent,
    PrivateClassLessonContainerComponent,
    PrivateClassLessonElementComponent,
    PrivateClassUpsellBannerComponent,
    LiveClassStateViewTimerComponent,
    LiveClassStateViewTitleComponent,
    PrivateClassBannerContainerComponent,
    PrivateClassHeaderComponent,
    PrivateClassThankYouModalComponent,
    PrivateClassFeedbackModalComponent,
    PrivateClassBannerImageComponent,
    PrivateClassLeftHeaderBannerComponent,
    PrivateClassStateLessonSelectComponent,
    PrivateClassStateSignUpConfirmComponent,
    PrivateClassStateSignedUpComponent,
    PrivateClassStateHasJoinComponent,
    PrivateClassStateNoneComponent,
    PrivateClassStateCanSignUpComponent,
    PrivateClassStateLockedComponent,
    PrivateClassCenterHeaderBannerComponent,
    GroupClassTileStatesComponent,
    GroupClassStateCanSignUpComponent,
    GroupClassStateHasJoinComponent,
    GroupClassStateLockedComponent,
    GroupClassStateNoneComponent,
    GroupClassStateSignedUpComponent,
    GroupClassStateSignUpConfirmComponent,
    LiveClassWithCountdownTimerComponent,
    PrivateClassLessonDetailBoxComponent,
    PrivateClassDownloadSlidesLinkComponent
  ],
  exports: [LiveClassRevampSectionComponent],
  entryComponents: [PrivateClassThankYouModalComponent, PrivateClassFeedbackModalComponent],
})
export class LiveClassRevampModule {}

export const LESSON_SELECT_WAIT_TIME = 1000;



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/live-class-revamp.module.ts